import React, { useState } from "react";
import { Box } from "@mui/material";
import Typography from "../../../../components/Typography/Typography";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import { Button } from "../../../../components/Buttons";
import InputField from "../../../../components/InputFields/InputField";
import IconComponent from "../../../../components/Icon/IconComponent";
import CustomModal from "../../../../components/Modals/CustomModal";
import {
  BRAND,
  GREY,
  BASE,
  BORDER,
  HELP,
  PRIMARY,
} from "../../../../utils/constants/colors";
import { fontWeight, ICON_LABELS } from "../../../../utils/constants/UI";

const CustomCreditModal = ({ isOpen, onClose }) => {
  const [creditAmount, setCreditAmount] = useState("");
  const [calculatedPrice, setCalculatedPrice] = useState(null);
  const [isCalculating, setIsCalculating] = useState(false);

  const styles = {
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    inputWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    priceDisplay: {
      background: `linear-gradient(135deg, ${BRAND.PRIMARY} 0%, ${PRIMARY.W_800} 100%)`,
      borderRadius: "12px",
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "8px",
    },
    priceAmount: {
      fontSize: "48px",
      fontWeight: fontWeight.BOLD,
      color: BASE.WHITE,
    },
    priceLabel: {
      fontSize: "14px",
      fontWeight: fontWeight.REGULAR,
      color: "rgba(255, 255, 255, 0.9)",
    },
    infoBox: {
      background: HELP.W_50,
      border: `1px solid ${HELP.W_100}`,
      borderRadius: "8px",
      padding: "12px",
      display: "flex",
      gap: "12px",
      alignItems: "flex-start",
    },
    infoIcon: {
      fontSize: "20px",
      color: HELP.W_500,
      marginTop: "2px",
    },
    footerButtons: {
      display: "flex",
      gap: "12px",
      width: "100%",
    },
  };

  const handleCalculate = () => {
    setIsCalculating(true);
    // Simulate API call - Replace with actual API integration
    setTimeout(() => {
      const credits = parseInt(creditAmount);
      if (credits && credits > 0) {
        // Example pricing logic - replace with actual API response
        const pricePerCredit = 0.05; // $0.05 per credit
        const calculatedAmount = (credits * pricePerCredit).toFixed(2);
        setCalculatedPrice(calculatedAmount);
      }
      setIsCalculating(false);
    }, 500);
  };

  const handlePurchase = () => {
    // Handle purchase logic here
    console.log("Purchasing", creditAmount, "credits for $", calculatedPrice);
    onClose();
  };

  const handleClose = () => {
    setCreditAmount("");
    setCalculatedPrice(null);
    onClose();
  };

  const modalHeader = {
    heading: {
      id: "custom_credit_package",
      label: "Custom Credit Package",
    },
  };

  const modalFooter = {
    right: (
      <Box style={styles.footerButtons}>
        <Button
          label="Cancel"
          size={"md40"}
          variant={"ghost"}
          onClick={handleClose}
        />
        {!calculatedPrice ? (
          <Button
            label="Calculate Price"
            size={"md40"}
            variant={"primary"}
            onClick={handleCalculate}
            isLoading={isCalculating}
            disabled={!creditAmount || parseInt(creditAmount) <= 0}
          />
        ) : (
          <Button
            label="Purchase Now"
            size={"md40"}
            variant={"primary"}
            onClick={handlePurchase}
          />
        )}
      </Box>
    ),
  };

  return (
    <CustomModal
      open={isOpen}
      onClose={handleClose}
      header={modalHeader}
      footer={modalFooter}
      width="500px"
      blurBackdrop={true}
    >
      <Box style={styles.content}>
        <Box style={styles.infoBox}>
          <IconComponent iconLabel={ICON_LABELS.INFO} style={styles.infoIcon} />
          <TypographyInline
            size={"sm"}
            color={GREY.SECONDARY}
            fontWeight={fontWeight.REGULAR}
            label="Enter the number of credits you need, and we'll calculate the best price for you."
          />
        </Box>

        <Box style={styles.inputWrapper}>
          <Typography
            size={"sm"}
            color={GREY.QUATINARY}
            fontWeight={fontWeight.MEDIUM}
            label="Number of Credits"
          />
          <InputField
            size={"md40"}
            type="number"
            placeholder="Enter credit amount (e.g., 50000)"
            value={creditAmount}
            onChange={(e) => {
              setCreditAmount(e.target.value);
              setCalculatedPrice(null);
            }}
            variant="default"
          />
        </Box>

        {calculatedPrice && (
          <Box style={styles.priceDisplay}>
            <span style={styles.priceLabel}>Estimated Price</span>
            <span style={styles.priceAmount}>${calculatedPrice}</span>
            <span style={styles.priceLabel}>
              for {parseInt(creditAmount).toLocaleString()} credits
            </span>
          </Box>
        )}
      </Box>
    </CustomModal>
  );
};

export default CustomCreditModal;
